module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/screen1.f5036e28.png";